import React, { FunctionComponent } from 'react'
import { ClipPath, Defs, G, Path, Rect, Svg } from 'react-native-svg'

/**
 * World icon used on Mix Language Modal
 */
export const MixLanguageWorldIcon: FunctionComponent<MixLanguageWorldIconProps> = ({ width = 126, height = 124 }) => {
  return (
    <Svg width={width} height={height} viewBox='0 0 126 124' fill='none'>
      <G clip-path='url(#clip0_7362_5594)'>
        <Path
          d='M62.5183 0.302307C45.6954 0.302307 29.1199 8.01064 17.0496 21.4612C4.90113 35.0028 -1.01033 52.581 0.83863 69.6903C2.45321 84.6643 8.91155 97.7632 19.5235 107.542C29.6798 116.917 43.2996 122.62 57.8699 123.623C59.2761 123.714 60.7475 123.766 62.2319 123.766C73.7813 123.766 91.2813 120.589 102.57 111.643C117.701 99.6643 126.255 80.9924 125.461 61.6695C124.615 41.0575 117.271 25.107 103.638 14.2737C90.8647 4.14345 75.7605 1.33095 67.8959 0.562724C66.1121 0.393453 64.3152 0.302307 62.5313 0.302307'
          fill='white'
        />
        <Path
          d='M120.253 61.9038C120.995 79.8856 112.87 96.8517 99.3411 107.581C89.0286 115.745 71.3073 119.326 58.2343 118.44C30.9948 116.578 9.08069 97.5028 6.0208 69.1434C2.25778 34.4168 33.4687 2.42466 67.388 5.74497C86.6849 7.63299 118.482 18.7788 120.253 61.9038Z'
          fill='#FFD2C4'
        />
        <Path
          d='M98.8332 66.2658C97.8306 66.3309 96.828 66.4872 95.8254 66.6043C95.591 66.6304 95.3175 66.6564 95.0832 66.6955C81.9321 68.5314 69.6795 74.5991 62.0623 83.9351C62.0103 84.0002 61.9452 84.0783 61.8931 84.1564C61.1248 85.107 60.4087 86.1096 59.7186 87.1382C58.8332 88.4533 57.9998 89.7945 57.2056 91.1747C52.8175 98.9611 50.3566 107.959 50.2134 117.36C52.8175 117.88 55.4608 118.297 58.1821 118.479C61.1899 118.701 64.4582 118.649 67.8306 118.362C79.0545 117.451 91.3722 113.896 99.3149 107.62C107.557 101.097 113.755 92.2684 117.219 82.2945C118.729 77.9455 119.732 73.3882 120.109 68.7137C113.833 66.6174 106.711 65.732 98.8332 66.3309L98.8071 66.2788L98.8332 66.2658Z'
          fill='#85CCD5'
        />
        <Path
          d='M70.7865 108.662C73.1953 104.703 76.2552 100.732 76.3203 96.0836C76.4115 90.094 71.0208 84.9117 65.0964 84.0263C64.0938 83.8831 63.0651 83.857 62.0625 83.9091C62.0104 83.9872 61.9453 84.0523 61.8932 84.1304C60.1484 86.3049 58.599 88.6617 57.2188 91.1226C52.8307 98.9091 50.3698 107.906 50.2266 117.308C52.8307 117.828 55.474 118.245 58.1953 118.427C61.2031 118.649 64.4714 118.597 67.8438 118.31C67.6094 115.068 69.0417 111.552 70.7865 108.662Z'
          fill='#4D9116'
        />
        <Path
          d='M92.4139 84.0002C92.8696 85.2372 93.5597 86.4091 94.4712 87.3856C96.242 89.3648 98.742 90.6539 101.372 90.4195C106.411 89.9898 109.588 84.6382 114.315 82.8804C115.265 82.5158 116.255 82.3596 117.258 82.2294C118.768 77.8804 119.771 73.3231 120.148 68.6487C113.872 66.5523 106.75 65.6669 98.8722 66.2658C97.8696 66.331 96.867 66.4872 95.8644 66.6044C95.63 66.6304 95.3566 66.6565 95.1222 66.6955C94.2368 68.3882 93.4686 70.2502 92.8045 72.3987C91.6327 76.1747 91.0858 80.3023 92.4399 84.0263L92.4139 84.0002Z'
          fill='#4D9116'
        />
        <Path
          d='M82.8177 100.263C82.7005 100.341 82.5573 100.432 82.4401 100.524C80.0964 102.359 74.9401 109.912 79.6406 111.643C83.3385 113.011 87.0234 108.349 87.8828 105.393C88.7682 102.294 86.6849 97.8673 82.8177 100.263Z'
          fill='#4D9116'
        />
        <Path
          d='M61.2815 28.4923C56.3856 27.0079 51.2554 27.1251 46.2164 27.2683C40.2007 27.4636 33.8466 27.1902 29.0289 31.5652C25.1356 35.0938 23.7033 40.5365 23.5601 45.5105C23.4169 50.6928 22.7919 56.7605 24.9924 61.7214C28.2216 69.0001 34.9924 68.935 41.8934 68.8178C46.1643 68.7527 50.8518 68.935 55.2138 68.5834C57.4533 70.3933 60.7476 71.9949 63.8856 72.9584C64.3153 73.1016 64.6929 72.672 64.4846 72.2683C63.6513 70.7839 63.0002 68.8959 62.7398 67.086C67.8309 65.224 71.3596 61.3308 71.3596 53.2188C71.3596 43.1928 72.9872 32.0209 61.2815 28.4792V28.5053V28.4923Z'
          fill='white'
        />
        <Path
          d='M30.4349 46.6173C28.5208 49.9116 33.8724 52.659 35.5 49.2866C36.151 47.9715 35.5521 46.1876 34.263 45.5106C32.974 44.8465 31.1771 45.3413 30.4479 46.6303V46.6043L30.4349 46.6173Z'
          fill='#85CCD5'
        />
        <Path
          d='M48.1954 46.0446C45.5391 43.3232 41.4636 47.6982 44.2501 50.1982C45.3438 51.1748 47.2058 51.0836 48.2084 50.0289C49.211 48.9742 49.211 47.0862 48.1824 46.0446H48.1954Z'
          fill='#85CCD5'
        />
        <Path
          d='M59.6535 50.8492C63.4556 50.5888 62.7525 44.6383 59.0545 45.1721C57.5962 45.3674 56.4504 46.8388 56.6196 48.2971C56.7889 49.7554 58.1952 50.9534 59.6795 50.8492H59.6535Z'
          fill='#85CCD5'
        />
      </G>
      <Defs>
        <ClipPath id='clip0_7362_5594'>
          <Rect width='125' height='123.464' fill='white' transform='translate(0.5 0.302063)' />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

type MixLanguageWorldIconProps = {
  width?: number
  height?: number
}
